<template>
  <div>
    <v-card class="grey lighten-4" :img="app.bkBuscador">
      <v-card-text>
        <BuscadorTarifario v-if="ready" :plano="$vuetify.breakpoint.smAndDown ? 'column' : 'row'" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex"
import { mapGetters } from "vuex"
import BuscadorTarifario from "@/components/tarifario/BuscadorTarifario.vue"

import moment from "moment"
export default {
  name: "indxTarifario",
  components: {
    BuscadorTarifario
  },
  mounted() {},
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.limpiarCarrito()
      this.setApp()
      this.$store.dispatch("app/setFormSave", null)
      this.$store.dispatch("app/setFormSaveTicket", null)
    },
    async setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
      await this.$store.dispatch("app/saveFormConfigHtl", this.formConfig)
      this.ready = true
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      formConfig: {
        picker: {
          startDate: moment()
            .add(-30, "days")
            .format("YYYY-MM-DD"),
          endDate: moment()
            .add(730, "days")
            .format("YYYY-MM-DD"),
          minNights: 1,
          i18n: {
            night: "Noche",
            nights: "Noches",
            "day-names": moment.localeData("es").weekdaysMin(),
            "check-in": "Desde",
            "check-out": "Hasta",
            "month-names": moment.localeData("es").months()
          }
        },
        bg: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/hoteleria.jpg"
      },
      ready: false
    }
  },
  computed: {
    ...mapGetters("app", {
      app: "getApp"
    })
  }
}
</script>
